import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import storeSearchContainerSelector from './store_search_container_selector'
import currentViewSelector from 'redux/selectors/ui/currentViewSelector'
import hasActivityBanksAccessSelector from 'redux/selectors/user/has_activity_banks_access_selector'
import { localize } from 'helpers/translator'

const getStore = state => state.store

const viewsToTitles = {
	[viewTypes.TIME_TO_CLIMB_CREATION]: localize('activity_banks_title_ttc'),
	[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: localize('activity_banks_title_ttc'),
	[viewTypes.DRAW_IT_CREATION]: localize('activity_banks_title_drawIt'),
	[viewTypes.DRAW_IT_STANDALONE_CREATION]: localize('activity_banks_title_drawIt'),
	[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: localize('activity_banks_title_matchingPairs'),
	[viewTypes.MATCHING_PAIRS_CREATION]: localize('activity_banks_title_matchingPairs'),
}

const viewsToSearchPlaceholders = {
	[viewTypes.TIME_TO_CLIMB_CREATION]: localize('activity_banks_search_placeholder_ttc'),
	[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: localize('activity_banks_search_placeholder_ttc'),
	[viewTypes.DRAW_IT_CREATION]: localize('activity_banks_search_placeholder_drawIt'),
	[viewTypes.DRAW_IT_STANDALONE_CREATION]: localize('activity_banks_search_placeholder_drawIt'),
	[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: localize('activity_banks_search_placeholder_matchingPairs'),
	[viewTypes.MATCHING_PAIRS_CREATION]: localize('activity_banks_search_placeholder_matchingPairs'),
}

const storeActivityBanksSelector = createSelector(
	[ hasActivityBanksAccessSelector, getStore, storeSearchContainerSelector, currentViewSelector ],
	(hasActivityBanksAccess, storeData, storeSearchData, currentView) => ({
		isEnabled: hasActivityBanksAccess,
		results: storeSearchData.lessons,
		totalSelectedFilters: storeData.confirmedFilters.length,
		query: storeSearchData.query,
		showNoResultsMessage: storeSearchData.showNoResultsMessage,
		currentSearchQuery: storeSearchData.currentSearchQuery,
		title: viewsToTitles[currentView] || '',
		searchPlaceholder: viewsToSearchPlaceholders[currentView] || '',
		hasMoreResults: storeSearchData.hasMoreResults,
		showLoadingMore: storeSearchData.showLoadingMore,
	})
)

export default storeActivityBanksSelector
